/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Level2OuterPageLoading } from "@octopusdeploy/design-system-components";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent";
import { createErrorInfoFromErrors } from "~/components/PageContent/createErrorInfo";
import { repository } from "../../clientInstance";
import InternalRedirect from "../../components/Navigation/InternalRedirect/InternalRedirect";
interface RunbookRunToRunbookTaskRedirectProps {
    spaceId: string;
    runbookRunId: string;
}
interface RunbookRunToRunbookTaskRedirectState extends DataBaseComponentState {
    redirectTo: LinkHref;
}
export default class RunbookRunToRunbookTaskRedirect extends DataBaseComponent<RunbookRunToRunbookTaskRedirectProps, RunbookRunToRunbookTaskRedirectState> {
    constructor(props: RunbookRunToRunbookTaskRedirectProps) {
        super(props);
        this.state = {
            redirectTo: null!,
        };
    }
    async componentDidMount() {
        await this.doBusyTask(async () => {
            const runbookRunId = this.props.runbookRunId;
            const runbookRun = await repository.RunbookRuns.get(runbookRunId);
            const runbookSnapshot = await repository.RunbookSnapshots.get(runbookRun.RunbookSnapshotId);
            const path = links.runbookRunPage.generateUrl({
                spaceId: this.props.spaceId,
                projectSlug: runbookSnapshot.ProjectId,
                runbookId: runbookSnapshot.RunbookId,
                runbookRunId: runbookRun.Id,
                runbookSnapshotId: runbookSnapshot.Id,
            });
            this.setState({
                redirectTo: path,
            });
        });
    }
    render() {
        const redirectTo = this.state.redirectTo;
        if (!redirectTo) {
            const errorInfo = this.errors ? createErrorInfoFromErrors(this.errors) : undefined;
            return (<main>
                    <Level2OuterPageLoading errors={errorInfo}/>
                </main>);
        }
        return <InternalRedirect push={false} to={redirectTo}/>;
    }
    static displayName = "RunbookRunToRunbookTaskRedirect";
}
